import { all, put, call, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { getErrorMsg } from "lib/fetch";
import * as actions from "./actions";

function* loadMasterUser(action) {
  const {
    data: {
      page,
      pageSize,
      searchName,
      companyID,
      orderBy,
      orderType,
      accessToken,
      filterObj,
      is_super
    }
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_GO_API_ENDPOINT}/users`,
      // `http://booking-api/api/customer`,
      {
        searchName,
        page,
        pageSize,
        companyID,
        orderBy,
        orderType,
        filterObj,
        is_super
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadMasterUser.success(res.data, page));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadMasterUser.failure());
  }
}

function* createMasterUser(action) {
  const {
    data,
    loading
  } = action.payload;
  // console.log(dataVisibilityNode)
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_GO_API_ENDPOINT}/users/create`,
      data,
      { headers: { Authorization: `Bearer ${data.accessToken}` } }
    );
    loading(res.data);
    yield put(actions.createMasterUser.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.createMasterUser.failure(getErrorMsg(err)));
  }
}

function* loadDetailMasterUser(action) {
  const {
    data: { id, accessToken }
  } = action.payload;

  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_GO_API_ENDPOINT}/user/detail/${id}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadDetailMasterUser.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadDetailMasterUser.failure());
  }
}

function* loadDetailMasterDataForEdit(action) {
  const {
    data: { id, accessToken }
  } = action.payload;

  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_GO_API_ENDPOINT}/users/${id}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadDetailMasterDataForEdit.success(res.data.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadDetailMasterDataForEdit.failure());
  }
}

function* updateMasterDataUser(action) {
  const {
    accessToken,
    data,
    loading
  } = action.payload;
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_GO_API_ENDPOINT}/users/update/${data.id_m_user}`,
     data,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    loading(res.data);
    yield put(actions.updateMasterDataUser.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.updateMasterDataUser.failure(getErrorMsg(err)));
  }
}

export default function* watchUserMasterData() {
  yield all([
    takeEvery(actions.LOAD_MASTERDATA_USER.REQUEST, loadMasterUser),
    takeEvery(actions.CREATE_MASTERDATA_USER.REQUEST, createMasterUser),
    takeEvery(actions.LOAD_DETAILMASTERDATA_USER.REQUEST, loadDetailMasterUser),
    takeEvery(
      actions.LOAD_DETAILMASTERDATA_FOR_EDIT.REQUEST,
      loadDetailMasterDataForEdit
    ),
    takeEvery(actions.UPDATE_MASTERDATA_USER.REQUEST, updateMasterDataUser),
  ]);
}
export {
  loadMasterUser,
  createMasterUser,
  loadDetailMasterUser,
  loadDetailMasterDataForEdit,
  updateMasterDataUser,
};
